// src/components/NewMenu.js
import * as React from 'react';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import ListItemIcon from '@mui/material/ListItemIcon';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

import * as Feed from '../Feed';
import { Global } from '../Global';

// 🔹 i18n
import { useI18n } from '../i18n/I18nContext';

export default function NewMenu(props) {
  const { anchorEl, setAnchorEl, setOpen } = props;
  const isOpen = Boolean(anchorEl);

  const { t } = useI18n(); // 🔹 Hook de tradução

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Menu
      anchorEl={anchorEl}
      open={isOpen}
      placement="right-start"
      onClose={handleClose}
      anchorOrigin={{
        vertical: "center",
        horizontal: "center",
      }}
    >
      {/* Clone example feed */}
      <MenuItem
        onClick={() => {
          const feed = Feed.exampleFeed();
          Global.setFeed({ ...feed });
          setOpen(false);
          handleClose();
        }}
      >
        <ListItemIcon>
          <FileCopyIcon />
        </ListItemIcon>
        {t("newMenuCloneExample")}
      </MenuItem>

      {/* Clone default feed */}
      <MenuItem
        onClick={() => {
          Global.openBusyScreen(true, t("newMenuBusyCloning"));
          Feed.loadFeedFromUrl(Feed.getDefaultFeedUrl(), false)
            .then((feed) => {
              Global.setFeed(feed);
            })
            .catch((msg) => {
              Global.displayMessage(msg);
            })
            .finally(() => {
              Global.openBusyScreen(false);
              setOpen(false);
              handleClose();
            });
        }}
      >
        <ListItemIcon>
          <FileCopyIcon />
        </ListItemIcon>
        {t("newMenuCloneDefault")}
      </MenuItem>

      {/* Empty new feed */}
      <MenuItem
        onClick={() => {
          const feed = Feed.newFeed();
          Global.setFeed({ ...feed });
          setOpen(false);
          handleClose();
        }}
      >
        <ListItemIcon>
          <InsertDriveFileIcon />
        </ListItemIcon>
        {t("newMenuEmptyFeed")}
      </MenuItem>
    </Menu>
  );
}